import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  tileWrapper: {
    gap: '20px',
    display: 'flex',
  },
}));
